import React from "react";
import { Link } from "react-router-dom";
import { PublicHeader } from "@/components/PublicHeader";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { SEO_FOR_COMPANIES } from "@/lib/seo-defs";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, CheckCircle2 } from "lucide-react";

export default function ForCompaniesPage() {
  return (
    <div className="min-h-screen">
      <SEO {...SEO_FOR_COMPANIES} />
      <PublicHeader />
      <section className="pt-28 pb-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Badge className="bg-[#EAF0FF] text-[#2D6BFF] border-0">Per le imprese</Badge>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
            Inserisci competenze direzionali nel punto in cui generano più valore.
          </h1>
          <p className="mt-5 text-lg text-slate-600">
            CXOORA è pensata per imprenditori e dirigenti di PMI italiane, aziende familiari, startup, scale-up e imprese tecniche/industriali in fase di crescita o trasformazione.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <Link to="/checkup"><Button size="lg" className="bg-[#2D6BFF] hover:bg-[#1F57F2] text-white h-12 px-6">Avvia il check-up <ArrowRight size={16} className="ml-2" /></Button></Link>
            <Link to="/soluzioni"><Button size="lg" variant="outline" className="h-12 px-6">Vedi le soluzioni</Button></Link>
          </div>
        </div>
      </section>
      <section className="py-12 bg-[#F6F8FC]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Cosa otterrai</h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              ["Check-up gratuito", "Un'analisi guidata in 8 step per identificare il bisogno reale."],
              ["Shortlist curata", "Massimo 3 manager validati dal team CXOORA, non centinaia di profili."],
              ["Match score trasparente", "Compatibilità calcolata su ruolo, settore, esperienza, disponibilità e budget."],
              ["Workspace condiviso", "Milestone, KPI, documenti, messaggi e timeline in un'unica piattaforma."],
              ["Costi proporzionati", "Paghi le giornate o i mesi di servizio effettivamente concordati."],
              ["Dati protetti", "Documenti riservati, accesso controllato, audit log."],
            ].map(([t, d]) => (
              <div key={t} className="flex gap-3 cxo-card p-4">
                <CheckCircle2 size={20} className="text-[#1F9D6A] shrink-0" />
                <div><p className="font-semibold text-slate-900">{t}</p><p className="text-sm text-slate-600">{d}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
